/**
 * @abwang
 * 花样PC整合项目
 * icon-subtract
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './index.less'

export default class IconClose extends Component {
    constructor(props, context) {
        super(props, context)
    }
    render() {
        return (
            <i className={classnames('icon icon-close', this.props.className)}>
                <svg width="12" height="12" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <line x1="1" y1="11" x2="11" y2="1" strokeWidth="2" />
                    <line x1="1" y1="1" x2="11" y2="11" strokeWidth="2" />
                </svg>
            </i>
        )
    }
}

IconClose.PropTypes = {}
